module.exports = __webpack_public_path__ + "static/img/200289.8d7aba06.png";